import React, { useState } from "react";
import BackgroundImage from "./../images/contactus_background.png";
import { useNavigate } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import { trackEvent } from "../lib/metaPixel";
import "./ContactUsPage.css";

const ContactUsPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const result = await axiosReqConfig(
      `${API_IP}/api/contact-us`,
      "post",
      formData,
    );

    setIsSubmitting(false);

    if (result?.ok) {
      trackEvent("Contact");
      alert("Thank you! Your message has been sent.");
      setFormData({ name: "", email: "", message: "" });
    } else {
      alert("Failed to send message. Please try again later.");
    }
  };

  return (
    <div className="CU-container">
      <div
        className="CU-hero"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className="CU-hero-content">
          <h1 className="CU-title">Contact Us</h1>
        </div>
      </div>

      <div className="CU-main-content">
        <div className="CU-intro-text">
          <h2>We’re here to help</h2>
          <p>
            Get in touch, ask questions, or book a free in-home or virtual
            consultation with our care team.
          </p>
        </div>

        <div className="CU-cards-grid">
          <div className="CU-info-card">
            <h3>iCare Village – Head Office</h3>
            <div className="CU-info-details">
              <p>
                <strong>Email:</strong> info@icaresolutions.ca
              </p>
              <p>
                <strong>Phone:</strong> +1 (250) 507 4262
              </p>
              <p>
                <strong>Mailing address:</strong>
              </p>
              <p>4088 Interurban Rd, Victoria, BC, V8Z4W7</p>
            </div>
          </div>

          <div
            className="CU-action-card"
            onClick={() => navigate("/consultation")}
          >
            <img
              className="CU-action-icon"
              src={require("../images/book_consultation_icon.png")}
              alt="Consultation"
            />
            <h4>Free Consultation</h4>
            <p>
              We’re here to support you. Book a complimentary, no-obligation
              in-home or virtual consultation.
            </p>
            <button className="CU-action-btn CU-btn-teal">
              Book Consultation
            </button>
          </div>

          <div
            className="CU-action-card"
            onClick={() => navigate("/platform-orientation")}
          >
            <img
              className="CU-action-icon CU-icon-hue"
              src={require("../images/book_consultation_icon.png")}
              alt="Orientation"
            />
            <h4>Platform Orientation</h4>
            <p>
              A free session to help you understand and use the iCare Village
              platform. Need help booking?
            </p>
            <button className="CU-action-btn CU-btn-orange">
              Request Orientation
            </button>
          </div>
        </div>

        <div className="CU-form-wrapper">
          <div className="CU-form-container">
            <h2>Send us a message</h2>
            <form onSubmit={handleSubmit}>
              <div className="CU-form-group">
                <label>Your full name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="e.g. John Doe"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="CU-form-group">
                <label>Your email address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="e.g. john@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="CU-form-group">
                <label>How can we help you?</label>
                <textarea
                  name="message"
                  rows="5"
                  placeholder="Tell us a little about your needs..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button
                type="submit"
                className="CU-submit-btn"
                disabled={isSubmitting}
                style={{ opacity: isSubmitting ? 0.7 : 1 }}
              >
                {isSubmitting ? "Sending..." : "Send Message to Care Team"}
              </button>
              <p className="CU-form-note">
                A real person from our care team will get back to you within one
                business day.
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
